import type { SVGProps } from 'react';

const SparklesIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9.09002 5.03109C9.15062 4.77431 9.51607 4.77431 9.57666 5.03109L10.2451 7.86382C10.3104 8.14035 10.5263 8.35627 10.8028 8.42152L13.6355 9.08996C13.8923 9.15055 13.8923 9.51601 13.6355 9.5766L10.8028 10.245C10.5263 10.3103 10.3104 10.5262 10.2451 10.8027L9.57666 13.6355C9.51607 13.8923 9.15062 13.8923 9.09002 13.6355L8.42158 10.8027C8.35633 10.5262 8.14041 10.3103 7.86388 10.245L5.03115 9.5766C4.77437 9.51601 4.77437 9.15055 5.03115 9.08996L7.86388 8.42152C8.14041 8.35627 8.35633 8.14035 8.42158 7.86382L9.09002 5.03109Z" />
      <path d="M4.23601 2.41248C4.26025 2.30977 4.40643 2.30977 4.43067 2.41248L4.83511 4.12645C4.87862 4.31081 5.02256 4.45475 5.20692 4.49826L6.92089 4.9027C7.0236 4.92694 7.0236 5.07312 6.92089 5.09735L5.20692 5.5018C5.02256 5.5453 4.87862 5.68925 4.83511 5.8736L4.43067 7.58757C4.40643 7.69028 4.26025 7.69028 4.23601 7.58757L3.83157 5.8736C3.78807 5.68925 3.64412 5.5453 3.45976 5.5018L1.7458 5.09735C1.64308 5.07312 1.64308 4.92694 1.7458 4.9027L3.45976 4.49826C3.64412 4.45475 3.78807 4.31081 3.83157 4.12645L4.23601 2.41248Z" />
      <path d="M9.33333 2.00004C9.33333 2.36823 9.03486 2.66671 8.66667 2.66671C8.29848 2.66671 8 2.36823 8 2.00004C8 1.63185 8.29848 1.33337 8.66667 1.33337C9.03486 1.33337 9.33333 1.63185 9.33333 2.00004Z" />
    </svg>
  );
};

export default SparklesIcon;
